import scheduleStationDialogCtrl from "./scheduleStationDialog/scheduleStationDialog.controller";
import scheduleStationDialog from "./scheduleStationDialog/scheduleStationDialog.html";
import changeDialogCtrl from "./changeDialog/changeDialog.controller";
import changeDialog from "./changeDialog/changeDialog.html";
import conflictingDialogCtrl from "../../components/conflictingDialog/conflictingDialog.controller";
import conflictingDialog from "../../components/conflictingDialog/conflictingDialog.html";

class Controller {
  constructor($injector, $stateParams, $mdDialog, GoogleMaps) {
    "ngInject";

    this.$mdDialog = $mdDialog;
    this.$stateParams = $stateParams;
    this.Events = $injector.get("Events");
    this.Backup = $injector.get("Backup");
    this.Ride = $injector.get("Ride");
    this.RidesTransforms = $injector.get("RidesTransforms");
    this.sections = $injector.get("Sections").routesSections;
    this.BackupTransforms = $injector.get("BackupTransforms");
    this.backupStatus = $injector.get("Lists").all.backupStatus;
    this.googleMapsUrl = GoogleMaps.getSource();
    this.onUpdateEvent = this.Events.getUpdateEvent("backup");
  }

  $onInit() {
    this.getConfirmDialog = (title, confirmClick) =>
      this.$mdDialog
        .confirm()
        .title(title)
        .ok(confirmClick || "Ok")
        .cancel("Cancel");
    this.showNotificationEvent = this.Events.eventsType.onShowSuccessNotification;
    this.errorEvent = this.Events.eventsType.onShowErrorNotification;
    this.getBackupDetails();
    this.Ride.getAll({ backup: this.$stateParams.id }).$promise.then(
      (response) => {
        this.rides = this.RidesTransforms.justify(response.hits);
      },
      (response) => this.Events.emit(this.errorEvent, response.data)
    );

    this.Events.on(this.onUpdateEvent, this.onUpdate.bind(this));
  }

  getBackupDetails() {
    this.Backup.get(this.$stateParams.id).$promise.then(
      (response) => {
        this.backup = this.BackupTransforms.justify(response);
      },
      (response) => this.Events.emit(this.errorEvent, response.data)
    );
  }

  showConflictDialog(captainConflict) {
    const timezone = this.backup.city.timezone;
    this.$mdDialog.show({
      controller: conflictingDialogCtrl,
      controllerAs: "$ctrl",
      template: conflictingDialog,
      locals: {
        captainConflict,
        timezone,
      },
    });
  }
  scheduleStation() {
    const backup = this.$stateParams.id;
    const schedule = this.$mdDialog.show({
      controller: scheduleStationDialogCtrl,
      controllerAs: "$ctrl",
      template: scheduleStationDialog,
      locals: { backup },
    });

    schedule.then((obj) => {
      this.Backup.schedule(this.$stateParams.id, obj).$promise.then(
        (response) => {
          this.backup = this.BackupTransforms.justify(response);
          this.Events.emit(this.showNotificationEvent, {
            message: "Your backup arrived successfully",
          });
        },
        (response) => this.Events.emit(this.errorEvent, response.data)
      );
    });
  }

  onUpdate(item) {
    const updatedItem = {};
    updatedItem[item.key] =
      typeof item.value !== "undefined"
        ? item.value
        : item.name
        ? item.name._id
        : null;

    this.Backup.updateAction(
      this.$stateParams.id,
      item.methodName,
      updatedItem
    ).$promise.then(
      () => {
        this.backup[item.key].isDisabled = true;
        this.Events.emit(this.showNotificationEvent, {
          message: `Your backup "${item.key}" has been updated successfully`,
        });
      },
      (response) => {
        if (response.data.captainConflict) {
          const captainConflict = response.data.captainConflict;
          this.showConflictDialog(captainConflict);
        }
        this.Events.emit(this.errorEvent, response.data);
      }
    );
  }

  start() {
    const start = this.getConfirmDialog(
      "Are you sue you want to start this backup?"
    );
    this.$mdDialog.show(start).then(() => {
      this.Backup.start(this.$stateParams.id).$promise.then(
        (response) => {
          this.backup = this.BackupTransforms.justify(response);
          this.Events.emit(this.showNotificationEvent, {
            message: "Your backup started successfully",
          });
        },
        (response) => this.Events.emit(this.errorEvent, response.data)
      );
    });
  }

  end() {
    const end = this.getConfirmDialog(
      "Are you sue you want to end this backup?"
    );
    this.$mdDialog.show(end).then(() => {
      this.Backup.end(this.$stateParams.id).$promise.then(
        (response) => {
          this.backup = this.BackupTransforms.justify(response);
          this.Events.emit(this.showNotificationEvent, {
            message: "Your backup ended successfully",
          });
        },
        (response) => this.Events.emit(this.errorEvent, response.data)
      );
    });
  }

  cancel() {
    const cancel = this.getConfirmDialog(
      "Are you sue you want to cancel this backup?"
    );
    this.$mdDialog.show(cancel).then(() => {
      this.Backup.cancel(this.$stateParams.id).$promise.then(
        (response) => {
          this.backup = this.BackupTransforms.justify(response);
          this.Events.emit(this.showNotificationEvent, {
            message: "Your backup cancelled successfully",
          });
        },
        (response) => this.Events.emit(this.errorEvent, response.data)
      );
    });
  }

  arrive() {
    const station = this.backup.backup_station._id;
    const arrive = this.getConfirmDialog(
      "Are you sue you want to confirm arriving to backup station?"
    );
    this.$mdDialog.show(arrive).then(() => {
      this.Backup.arrive(this.$stateParams.id, { station }).$promise.then(
        (response) => {
          this.backup = this.BackupTransforms.justify(response);
          this.Events.emit(this.showNotificationEvent, {
            message: "Your backup arrived successfully",
          });
        },
        (response) => this.Events.emit(this.errorEvent, response.data)
      );
    });
  }

  changeEntity(type) {
    const name = type === "captain" ? "update_captain" : "update_bus_type";
    const change = this.$mdDialog.show({
      controller: changeDialogCtrl,
      controllerAs: "$ctrl",
      template: changeDialog,
      locals: {
        type,
      },
    });

    change.then((data) => {
      this.Backup.updateAction(this.$stateParams.id, name, data).$promise.then(
        (response) => {
          this.Events.emit(this.showNotificationEvent, {
            message: `${type} changed successfully.`,
          });
          this.backupschedule = this.BackupTransforms.justify(response);
        },
        (response) => {
          if (response.data.captainConflict) {
            const captainConflict = response.data.captainConflict;
            this.showConflictDialog(captainConflict);
          }
          this.Events.emit(this.errorEvent, response.data);
        }
      );
    });
  }
}

export default Controller;



// WEBPACK FOOTER //
// ./src/pages/backup/backup.controller.js